import { Heading } from '@chakra-ui/react';

interface IProps {
  children: React.ReactNode;
  dataSelector?: string;
}

const PageHeader = (props: IProps) => {
  const { children, dataSelector } = props;

  return (
    <Heading data-selector={dataSelector} as="h1" mb={6} fontSize={{ base: '3xl', lg: '4xl' }} lineHeight="shorter">
      {children}
    </Heading>
  );
};

export { PageHeader };
